import type { FaireProductEntity } from "../../entity_types/product";

export const p_jtaqbpkzq2: FaireProductEntity = {
  token: "p_jtaqbpkzq2",
  type: "product",
  name: "3D Packaged Crew Socks - Camper at the Lake - Orange",
  brandName: "Living Royal",
  imageUrl:
    "https://cdn.faire.com/fastly/b56b504117582979b34f5fd651e9e695ad47dc509c7bac9b9006aac2fed292a4.jpeg",
  priceDollars: 4.75,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/e94fe766507ae81189cc72a4c240c64d424103d312357b0163eb4800fe3389e7.png",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
